export const acervoPessoalTypes = {
  armasPessoa: [
    {
      anexos: [],
    },
  ],
  ufs: [],
  finalidades: [],
}
